import { IZoneUpdate, ITableCreate, ITableUpdate } from './../../interfaces/index';
import { ActionContext } from "vuex";
import { State } from "../state";
import { IAdminTablesState } from "./state";
import { dispatchCheckApiError } from "../main/actions";
import { getStoreAccessors } from "typesafe-vuex";
import { commitSetTables, commitSetZones, commitSetZone, commitRemoveZone, commitSetTable, commitRemoveTableFromZone } from "./mutations";
import { api } from "../../api"
import { IZoneCreate } from "@/interfaces";

type MainContext = ActionContext<IAdminTablesState, State>;

export const actions = {
    async getZones(context: MainContext) {
        try {
            const branchId = context.rootState.main.currentSelectedBranch?.id;
            if (branchId !== undefined){
                const response = await api.getZones(context.rootState.main.token, branchId);
                if (response) {
                    commitSetZones(context, response.data);
                }
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async getZone(context: MainContext, id: number) {
        try {
            const response = await api.getZone(context.rootState.main.token, id);
            if (response) {
                commitSetZone(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async addZone(context: MainContext, payload: IZoneCreate) {
        try {
            const response = await api.addZone(context.rootState.main.token,
                payload);
            if(response) {
                commitSetZone(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async updateZone(context: MainContext, payload: {id: number, zone: IZoneUpdate}) {
        try {
            const response = await api.updateZone(context.rootState.main.token,
                payload.id,
                payload.zone);
            if(response) {
                commitSetZone(context, response.data);
            }
            
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async removeZone(context: MainContext, id: number) {
        try {
            const response = await api.deleteZone(context.rootState.main.token,
                id);
            if(response) {
                commitRemoveZone(context, id);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async getTables(context: MainContext) {
        try {
            const branchId = context.rootState.main.currentSelectedBranch?.id;
            if (branchId !== undefined){
                const response = await api.getTables(context.rootState.main.token, branchId);
                if (response) {
                    commitSetTables(context, response.data);
                }
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async getTable(context: MainContext, id: number) {
        try {
            const response = await api.getTable(context.rootState.main.token, id);
            if (response) {
                commitSetTable(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async addTable(context: MainContext, payload: ITableCreate) {
        try {
            const response = await api.addTable(context.rootState.main.token,
                payload);
            if(response) {
                await dispatchGetZone(context, response.data.zone_id);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async updateTable(context: MainContext, payload: {id: number, table: ITableUpdate}) {
        try {
            const response = await api.updateTable(context.rootState.main.token,
                payload.id,
                payload.table);
            if(response) {
                commitSetTable(context, response.data);
            }
            
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async removeTable(context: MainContext, id: number) {
        try {
            const response = await api.deleteTable(context.rootState.main.token,
                id);
            if(response) {
                let table_removed = response.data.id;
                let zone_id = response.data.zone_id;

                commitRemoveTableFromZone(context, {tableId: table_removed, zoneId: zone_id});
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

};

const { dispatch } = getStoreAccessors<IAdminTablesState, State>("");

export const dispatchGetZones = dispatch(actions.getZones);
export const dispatchGetTables = dispatch(actions.getTables);
export const dispatchGetZone = dispatch(actions.getZone);
export const dispatchGetTable = dispatch(actions.getTable);
export const dispatchAddZone = dispatch(actions.addZone);
export const dispatchAddTable = dispatch(actions.addTable);
export const dispatchUpdateZone = dispatch(actions.updateZone);
export const dispatchUpdateTable = dispatch(actions.updateTable);
export const dispatchRemoveZone = dispatch(actions.removeZone);
export const dispatchRemoveTable = dispatch(actions.removeTable);

